import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { MdFavoriteBorder, MdOutlineAddShoppingCart } from 'react-icons/md';

const ButtonCard = ({ product, onAddToFavorites, onAddToCart, handleDetailClick }) => {
    return (
        <Row className="g-1"> {/* Add spacing between columns with g-1 */}
            {/* Add to Favorites Button */}
            {/* <Col xs={6} md={2} lg={2}>
                <Button
                    style={{
                        background: '#8d070e',
                        color: 'white',
                        border: '1px solid #8d070e',
                        transition: 'all 0.3s ease-in-out'
                    }}
                    className="w-100 mb-1"
                    onClick={() => onAddToFavorites(product.id)}
                    onMouseEnter={(e) => {
                        e.target.style.background = "white";
                        e.target.style.color = "#8d070e";
                        e.target.style.border = "1px solid #8d070e";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = "#8d070e";
                        e.target.style.color = "white";
                        e.target.style.border = "1px solid #8d070e";
                    }}
                >
                    <MdFavoriteBorder size={15} />
                </Button>
            </Col> */}

            {/* Add to Cart Button */}
            <Col xs={6} md={2} lg={2}>
                <Button
                    style={{
                        background: '#8d070e',
                        color: 'white',
                        border: '1px solid #8d070e',
                        transition: 'all 0.3s ease-in-out'
                    }}
                    className="w-100 mb-1"
                    onClick={() => onAddToCart(product.id)}
                    onMouseEnter={(e) => {
                        e.target.style.background = "white";
                        e.target.style.color = "#8d070e";
                        e.target.style.border = "1px solid #8d070e";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = "#8d070e";
                        e.target.style.color = "white";
                        e.target.style.border = "1px solid #8d070e";
                    }}
                >
                    <MdOutlineAddShoppingCart size={15} />
                </Button>
            </Col>

            {/* View Details Button */}
            <Col xs={12} md={10} lg={10}>
                <Button
                    style={{
                        background: '#8d070e',
                        color: 'white',
                        border: '1px solid #8d070e',
                        transition: 'all 0.3s ease-in-out'
                    }}
                    className="w-100 mb-1"
                    onClick={() => handleDetailClick(product)}
                    onMouseEnter={(e) => {
                        e.target.style.background = "white";
                        e.target.style.color = "#8d070e";
                        e.target.style.border = "1px solid #8d070e";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = "#8d070e";
                        e.target.style.color = "white";
                        e.target.style.border = "1px solid #8d070e";
                    }}
                >
                    <span style={{ fontSize: 13 }}>Lihat Detail</span>
                </Button>
            </Col>
        </Row>
    );
};

export default ButtonCard;